import { EntityEditFormModal } from '../../Entity'

import { USER_EDIT_ROLE_MODAL_QA_NAME } from './UserEditRoleFormModal.constants'
import {
  getUserEditRoleFormModalSubmitPayload,
  getUserEditRoleFormModalValidationSchema,
} from './UserEditRoleFormModal.utils'
import { UserEditRoleFormModalFields } from './UserEditRoleFormModalFields'

function UserEditRoleFormModal({
  Fields = UserEditRoleFormModalFields,
  getPayload = getUserEditRoleFormModalSubmitPayload,
  initialValues,
  needToCheckNoChanges = true,
  ...restProps
}) {
  const validationSchema = getUserEditRoleFormModalValidationSchema(
    initialValues,
    needToCheckNoChanges
  )

  return (
    <EntityEditFormModal
      {...restProps}
      Fields={Fields}
      getPayload={getPayload}
      initialValues={initialValues}
      qaName={USER_EDIT_ROLE_MODAL_QA_NAME}
      validationSchema={validationSchema}
    />
  )
}

export default UserEditRoleFormModal
